// extracted by mini-css-extract-plugin
module.exports = {"required-indicator-content":"required-indicator-content-2kJVCBQ"};